<template>
    <div :class="['padding_bottom_64',{'bodyfixed':ismodalshow,'bodyauto':!ismodalshow}]">
        <div class="margin_top_100">
            <div class="banner"  :style="'backgroundImage:url('+rankdata.detailBannerPc+')'"></div>
            <div class="inner display_flex justify-content_flex-justify padding-32">
                <div class="reportcontian">
                    <div class="report_title">{{rankdata.title}}</div>
                    <div class="padding_16"><span class="report_time">{{$t('rankindex.chupinfang')}} · {{$t('rankindex.report_fishqc')}} · {{formatTimefun(rankdata.publishTime)}}</span><div  :class="['collect_btn_top',{'active':rankdata.favor}]" @click="collect()">{{$t('product.collectrank')}}</div></div>
                    <div class="report_desc" v-html="rankdata.introductory"></div>
                    
                    <div v-if="rankdata.rankType == '1'">
                        <!-- <div class="title_box">
                            <div class="report_subtitle">检测结果</div>
                            <div class="title_line"></div>
                        </div>
                        <div class="testresult">产品安全性测试结果</div>
                        <div class="result1">在我们测试的 30 款面膜样本中，绿鱼（ 品质卓越 ）的样本有 18 款，黄鱼（ 品质及格 ）的样本有 6 款，红鱼（ 有待改善 ）的样本有 4 款。</div>
                        <div class="display_flex justify-content_flex-justify align-items_center">
                            <div class="display_flex flex-wrap_wrap padding_top_28">
                                <div class="padding_right64">
                                    <div class="resultNum">30</div>
                                    <div class="resultdesc">测试样本数量</div>
                                </div>
                                <div>
                                    <div class="resultNum">12</div>
                                    <div class="resultdesc">样本品牌数量</div>
                                </div>
                            </div>
                            <div class="display_flex justify-content_flex-justify padding_top_20">
                                <div class="">
                                    <div class="position_relative">
                                        <img src="http://p1.fishqc.net/FjFwYIpjv8nV8yrfUg8O1ByMm-EF" class="vertical-middle fishimg">
                                        <span class="fishqcround green vertical-middle">18</span>
                                    </div>
                                    <div class="fishdesc">品质卓越</div>
                                </div>
                                <div class="padding_left_42">
                                    <div class="position_relative">
                                        <img src="http://p1.fishqc.net/FkwJBCGNGbTokp_j7_k_YDjS7LM5" class="vertical-middle fishimg">
                                        <span class="fishqcround yellow vertical-middle">18</span>
                                    </div>
                                    <div class="fishdesc">品质合格</div>
                                </div>
                                <div class="padding_left_42">
                                    <div class="position_relative">
                                        <img src="http://p1.fishqc.net/Fsj1cltSch3P6j5y4HuKnx8r_Y9q" class="vertical-middle fishimg">
                                        <span class="fishqcround red vertical-middle">18</span>
                                    </div>
                                    <div class="fishdesc">有待改善</div>
                                </div>
                            </div>
                        </div>
                        <div class="desc2">小鱼亲测在市面上挑选了30款畅销面霜，会同专业实验室，应用全球领先的生物测试技术Testing 2.0对其安全性进行测试，为你揭开这个谜底。最终17款产品为绿鱼（品质卓越），1款产品为黄鱼（基本合格），12款产品为红鱼（有待改善）。小鱼亲测发现，中间价格的面霜样本，安全性表现最为卓越；成分筛查测试中，有6款面霜样本含有禁用成分。</div>
                        <div class="testresult">产品功效测试结果</div>
                        <div class="result1">XX个【样本量】XX【产品类型】产品样本中，XX个【品牌数】品牌。就XX功效【功效类型】比较而言，XX个【功效显著数量】样本（XX%）评为功效显著，XX个【功效不显著数量】样本（XX%）评为功效不显著。</div>
                        <div class="display_flex justify-content_flex-justify align-items_center" style="padding-top:8px;">
                            <div class="display_flex flex-wrap_wrap padding_top_28">
                                <div class="padding_right64">
                                    <div class="resultNum">30</div>
                                    <div class="resultdesc">测试样本数量</div>
                                </div>
                                <div>
                                    <div class="resultNum">12</div>
                                    <div class="resultdesc">样本品牌数量</div>
                                </div>
                            </div>
                            <div class="display_flex justify-content_flex-justify padding_top_20 padding_right_184">
                                <div class="">
                                    <div class="position_relative">
                                        <span class="fishqcround green vertical-middle margin_left0">18</span>
                                    </div>
                                    <div class="fishdesc">功效显著</div>
                                </div>
                                <div style="margin-left:88px;">
                                    <div class="position_relative">
                                        <span class="fishqcround yellow vertical-middle margin_left0 grave">18</span>
                                    </div>
                                    <div class="fishdesc">功效不显著</div>
                                </div>
                            </div>
                        </div> -->
                        <div>
                            <div class="title_box">
                                <div class="report_subtitle" ref="greenrank" id="greenrank">{{$t('index.rankTitle')}}</div>
                                <div class="title_line"></div>
                                <div class="rankNum">1</div>
                            </div>
                            <div class="display_flex flex-wrap_wrap">
                                <div v-for="item in rankdata.prdList[0]" class="rankItem display_flex" @click="toproductdetail(item)">
                                    <div class="rankItem_productimg" >
                                        <div class="img" :style="'backgroundImage:url('+item.productImage+')'"></div>
                                    </div>
                                    <div class="flex_1 display_flex flex-direction_column horizontal-between">
                                        <div class="product_title">
                                            <div class="productname" style="">{{item.productName}}</div>
                                            <div class="product_bable" v-if="item.efficacy && item.efficacy.length > 0">{{$t('product.effecy_xianzhu')}}</div>
                                        </div>
                                        <div class=" productdetail display_flex justify-content_flex-justify align-items_center">
                                            <img src="../../assets/images/greenfish.png" height="65" width="66">
                                            <div class="productitemdetail">
                                                <div class="productitemdetails ">
                                                    <span class="fix-width-60">{{$t('product.size')}}</span>
                                                    <span class="color">{{item.size}}</span>
                                                </div>
                                                <div class="productitemdetails ">
                                                    <span class="fix-width-60">{{$t('product.price')}}</span>
                                                    <span class="color">{{item.price}}{{item.currency}}</span>
                                                </div>
                                                <div class="productitemdetails ">
                                                    <span class="fix-width-60">{{$t('index.address')}}</span>
                                                    <span class="color">{{item.originPlace}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for="item in 3"  v-if="rankdata.rankType == '2'">
                        <div class="title_box">
                            <div class="report_subtitle">榜单副标题</div>
                            <div class="title_line"></div>
                        </div>
                        <div class="desc3">
                            当00后也走上护肤之路，90后的各位“大妈”就难掩慌色了。汇聚多种精华于一小罐的面霜，被追捧成逆龄武器，仿佛一抹就能年轻10岁，早晚坚持还能冻龄。如此强大的面霜，起效的是真精华，还是禁用成分的化学作用？接下来，小鱼将为你揭晓！
                        </div>
                        <div class="display_flex flex-wrap_wrap">
                            <div v-for="item in 4" class="rankItem display_flex">
                                <div class="rankItem_productimg">
                                    <div class="img" :style="'backgroundImage:url('+item.productImage+')'"></div>
                                </div>
                                <div class="flex_1 display_flex flex-direction_column horizontal-between">
                                    <div class="product_title">
                                        <div>科颜氏</div>
                                        <div>亚马逊白泥净致面膜</div>
                                        <div class="product_bable">美白、保湿功效显著</div>
                                    </div>
                                    <div class=" productdetail display_flex justify-content_flex-justify align-items_center">
                                        <img src="../../assets/images/greenfish.png" height="65" width="66">
                                        <div class="productitemdetail">
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">规格</span>
                                                <span class="color">500 ml</span>
                                            </div>
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">参考价格</span>
                                                <span class="color">126.5 元</span>
                                            </div>
                                            <div class="productitemdetails ">
                                                <span class="fix-width-60">品牌所在地</span>
                                                <span class="color">中国香港</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div>
                        <div>
                            <div class="title_box">
                                <div class="report_subtitle" ref="standard">{{$t('rankindex.report_standard')}}</div>
                                <div class="title_line"></div>
                                <div class="rankNum">2</div>
                            </div>
                            <div>
                                <div v-for="item in rank_fish_desc" :class="['fishblock',item.class]">
                                    <div class="display_flex flex-wrap_wrap">
                                        <div>
                                            <img :src="item.fish">
                                        </div>
                                        <div class="padding_left_16 fishdiv">
                                            <div :class="['title',item.textcolor]">{{item.title}}</div>
                                            <div class="desc">{{item.desc}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="desc4">{{$t('rankindex.test_methor_desc1')}}</div>
                            </div>
                            <div class="title_box">
                                <div class="report_subtitle" ref="technology">{{$t('rankindex.fishqcintroduction')}}</div>
                                <div class="title_line"></div>
                                <div class="rankNum">3</div>
                            </div>
                            <div class="rank_introductdesc">{{$t('rankindex.fishqcintrocontent')}}</div>
                            <div class="eeq_contain display_flex justify-content_flex-justify">
                                <div  :class="['inline-block','textalign_center','rank_eeqdesc','vertical-top',{'fontSize12':currentlang== 'eng'}]">{{$t('rankindex.eeqtest')}}</div>
                                <div class="inline-block textalign_center vertical-top flex_1">
                                    <img src="http://p1.fishqc.net/Fn4HEb50oZA1dDQjrd1GJDTJNHNJ">
                                    <div class="rank_eeq_content">{{$t('rankindex.normalqingjiang')}}</div>
                                </div>
                                <div class="inline-block textalign_center rank_eeq_middle vertical-top">
                                    <div>{{$t('rankindex.qingjiangbaby')}}<br>{{$t('rankindex.meetq1')}}</div>
                                    <img src="http://p1.fishqc.net/Fge9_Uz24Zz5qrogdifC9fTrFXqe" class="eeq_margin">
                                    <div class="rank_eeq_num">{{$t('rankindex.after24')}}</div>
                                </div>
                                <div class="inline-block textalign_center vertical-top flex_1">
                                    <img src="http://p1.fishqc.net/FmNHaETAwTwi4EAKfsn2s7OtiuC5">
                                    <div class="rank_eeq_content" v-html="$t('rankindex.meetq2')"></div>
                                </div>
                            </div>
                            <div class="eeq_contain display_flex justify-content_flex-justify">
                                <div :class="['inline-block','textalign_center','rank_eeqdesc','vertical-top',{'fontSize12':currentlang== 'eng'}]">{{$t('rankindex.attest')}}</div>
                                <div class="inline-block textalign_center vertical-top flex_1">
                                    <img src="http://p1.fishqc.net/FonpyPBdHLT3sbOoWanyxb7kmMQA">
                                    <div class="rank_eeq_content">{{$t('rankindex.normalbanma')}}</div>
                                </div>
                                <div class="inline-block textalign_center rank_eeq_middle vertical-top">
                                    <div>{{$t('rankindex.qingjiangbaby')}} <br>{{$t('rankindex.meetq3')}}</div>
                                    <img src="http://p1.fishqc.net/Fge9_Uz24Zz5qrogdifC9fTrFXqe" class="eeq_margin">
                                    <div class="rank_eeq_num">{{$t('rankindex.after48')}}</div>
                                </div>
                                <div class="inline-block textalign_center vertical-top flex_1">
                                    <img src="http://p1.fishqc.net/Fr4tp7eTI7Hq7kLQOBwC6ECQCq6n">
                                    <div class="rank_eeq_content" v-html="$t('rankindex.meetq4')"></div>
                                </div>
                            </div>
                            <div class="eeq_contain display_flex justify-content_flex-justify">
                                <div :class="['inline-block','textalign_center','rank_eeqdesc','vertical-top','margin_top_12',{'fontSize16':currentlang== 'eng'}]">{{$t('rankindex.chengfen')}}</div>
                                <div class="inline-block textalign_center vertical-top flex_1">
                                    <img src="http://p1.fishqc.net/Fqa9YTRb1CItqVAv1cQV4LaYCBgu">
                                    <div class="rank_eeq_content three">{{$t('rankindex.chengfendesc')}}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="rankdata.efficacyTest !=null && rankdata.efficacyTest !=='0'">
                            <!--  -->
                            <div class="title_box" ref="efficacy">
                                <div class="report_subtitle" ref="efficacy" id="efficacy">功效测评科技</div>
                                <div class="title_line"></div>
                                <div class="rankNum">4</div>
                            </div>
                            <div v-if="rankdata.efficacyTest == '1'">
                                <div class="rank_effect_title">提亮测试--斑马鱼胚胎黑色素抑制测试</div>
                                <div class="rank_effect_subtitle">通过测量和计算受试样品对斑马鱼胚胎色素的抑制率来评估/筛查样本的美白功效。</div>
                                <div class="eeq_contain display_flex align-items_center">
                                    <div class="inline-block textalign_center rank_eeqdesc vertical-top"></div>
                                    <div class="inline-block textalign_center vertical-top">
                                        <img src="https://p1.fishqc.net/FtPjcSI5uCwXPJcilNUtxS7j5BU9">
                                        <div class="rank_eeq_content">测试前</div>
                                    </div>
                                    <div class="inline-block textalign_center rank_eeq_middle vertical-top">
                                        <!-- <div>将鱼胚胎暴露于产品测试溶液中</div> -->
                                        <img src="http://p1.fishqc.net/Fge9_Uz24Zz5qrogdifC9fTrFXqe" class="eeq_margin">
                                        <!-- <div class="rank_eeq_num">48h后</div> -->
                                    </div>
                                    <div class="inline-block textalign_center vertical-top">
                                        <img src="https://p1.fishqc.net/Fpts0dnZGd6WFBduZNrTGvBjfUG5">
                                        <div class="rank_eeq_content">测试后</div>
                                    </div>
                                </div>
                                <div class="rank_effect_result">斑马鱼与人类的黑色素都是通过调节络氨酸酶来合成的，通过抑制络氨酸酶，减少黑色素的产生来达到美白效果。斑马鱼胚胎个体小，光学通透性强，容易清楚观察及量化其体内黑色素。</div>
                            </div>
                            
                        </div>
                        
                    </div>
                    <!--  -->
                    
                    
                    <div>
                        <div  :class="['collect_btn',{'active':rankdata.favor}]" @click="collect()">{{$t('product.collectrank')}}</div>
                    </div>
                    <div class="display_flex  justify-content_flex-justify ">
                        <div class="publish">{{$t('rankindex.chupinfang')}} · {{$t('rankindex.report_fishqc')}} · {{formatTimefun(rankdata.publishTime)}}</div>
                       <!--  <div class="share" >
                            <span>分享到</span>
                            <div class="rank_share_icon" v-for="item in 3"></div>
                        </div> -->
                    </div>
                    
                </div>
                <div class="rankRight" :class="{'fixmenu':fixbox == true}" :style="{right:toolRight+'px'}">
                    <div class="reportmenu boxshadow" >
                        <div class="title">{{$t('rankindex.pc_listmenu')}}</div>
                     
                        <div v-for="(item,index) in rankmenu()" v-if="ranktype == 'single'">
                            <div v-if="item.show" :class="['title_list',{'active':item.title == currentranktitle}]" @click="scrollTo(item.title,item.position)">{{item.title}}</div>
                        </div>
                        
                       <!--  <div v-for="item in 5" v-if="ranktype == 'many'">
                            <div class="title_list">检查结果</div>
                        </div> -->
                    </div>
                    <div class="reportmenu margin_top_32" v-if="false">
                        <div class="title">下一篇榜单</div>
                        <div class="nextreport_title">检查结果</div>
                        <div>
                            <div class="display_flex  justify-content_flex-justify ">
                                <div class="content_bottom_L"> 2019/10/24</div>
                                <div class="content_bottom_R ">
                                    <span class="date">美妆</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>

</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.margin_top_100 {
    margin-top: 100px;
}
.margin_top_32{
    margin-top: 32px;
    box-shadow:0;
}
.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}

.padding-bottom-16 {
    padding: 0px 0 16px;
    box-sizing: border-box;
}

.content_bottom_L{
    display:inline-block;
    .date{
        padding-left:6px;
        box-sizing:border-box;
        color:#888888
    }
}
.content_bottom_R{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 12px;
    display:inline-block;
    padding:6px 16px;
    box-sizing:border-box;
    background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);
    border-radius: 0px 12px 12px 12px;
    
}

.reportmenu {
    width: 384px;
    max-height: 500px;
    padding: 0 32px 34px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #F4F4F5;
    text-align: left;
    
    &.boxshadow{
        box-shadow: 0 10px 30px 0 rgba(233, 233, 235, 0.3);
    }

    .title {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        padding: 26px 0 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #E5E5E5;
    }

    .title_list {
        margin-top: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 24px;
        position: relative;
        padding-left: 16px;
        cursor: pointer;

        &:hover {
            color: #60DEB4;
        }

        &:before {
            content: '';
            position: absolute;
            left: 0%;
            top: 50%;
            transform: translate(0, -50%);
            width: 8px;
            height: 8px;
            background: #60DEB4;
            border-radius: 56px;

        }

        &.active {
            color: #60DEB4;
        }
    }

    .nextreport_title{
        padding-top: 16px;
        padding-bottom: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333342;
        line-height: 24px;
    }
}

.padding_16 {
    padding: 16px 0;
    box-sizing: border-box;
}


.banner{
    height: 400px;
    background-color: #fff;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}


.reportcontian {
    width: 792px;
    text-align: left;

    .report_title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
    }

    .report_collect {
        display: inline-block;
        width: 64px;
        height: 24px;
        line-height: 24px;
        background: #60DEB4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 3px;
        text-align: center;
    }

    .report_time {
        line-height: 24px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        padding-right: 30px;
        box-sizing: border-box;
    }

    .report_desc {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .report_subtitle {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        padding-bottom: 18px;
        display: inline-block;
        
        padding-left: 2px;
        box-sizing: border-box;

    }

    .title_box {
        padding-top: 32px;
        box-sizing: border-box;
        position: relative;
        .title_line {
            margin-top: -2px;
            height: 2px;
            background: #F4F4F5;
            position: relative;
            &:before{
                width: 120px;
                height: 4px;
                background: #60DEB4;
                content:'';
                position: absolute;
                left:0;
                top:-1px;
            }
        }

        .rankNum{
            position: absolute;
            bottom: 0;
            right: 0;
            width: 24px;
            height: 24px;
            background: #F4F4F5;
            font-size: 24px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #FFFFFF;
            line-height: 24px;
            text-align: center;
        }
    }

    .testresult {
        padding: 16px 0 16px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        position: relative;

        &:before {
            content: '';
            position: absolute;
            left: 0%;
            top: 50%;
            transform: translate(0, -50%);
            width: 8px;
            height: 8px;
            background: #60DEB4;
            border-radius: 56px;

        }
    }
    .testresult_vs{
        width: 42px;
        height: 42px;
        background: #D5D5D7;
        display: inline-block;
        border-radius: 50%;
        font-size: 21px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 42px;
        text-align: center;
        vertical-align: middle;
        margin:104px 30px 0;
    }

    .padding_top_38{
        padding: 38px 0 22px;
        box-sizing: border-box;
    }
    .result1 {
        padding-left: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .resultNum {
        font-size: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 40px;
        padding-bottom: 10px;
    }

    .resultdesc {
        padding-top: 10px;
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        line-height: 14px;
        position: relative;


        &:before {
            content: '';
            position: absolute;
            top: 0;
            width: 40px;
            height: 1px;
            background-color: #F4F4F5;
            left: 0;

        }
    }

    .padding_top_28 {
        // padding-top: 28px;
        padding-left: 46px;
        box-sizing: border-box;
    }

    .padding_top_20 {
        // padding-top: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }

    .padding_right_184 {
        padding-right: 184px;
        box-sizing: border-box;
    }

    .padding_right64 {
        padding-right: 64px;
        box-sizing: border-box;
    }

    .padding_left_42 {
        padding-left: 12px;
        box-sizing: border-box;
    }

    .fishdesc {
        text-align: center;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        padding-top: 8px;
        box-sizing: border-box;
    }

    .fishimg {
        position: absolute;
        left: 22px;
        top: 50%;
        transform: translate(0, -50%);
    }

    .fishqcround {
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        display: inline-block;
        background-image: url('http://p1.fishqc.net/FjD4dfCGmBJ33_K3UcPUinzSx0De');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        // background-color: #53D5C2;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        border-radius: 50%;
        margin-left: 71px;
        padding-left: 6px;
        box-sizing: border-box;

        &.green {
            // background-color: #53D5C2;
        }

        &.yellow {
            // background-color: #FFDB69;
        }

        &.red {
            // background-color:#FF7338;
        }

        &.grave {
            background-image: url('http://p1.fishqc.net/FvyRjPY9ceyjmo3xS6t9e_0Jve2i');
        }

        &.margin_left0 {
            margin-left: 0;
        }
    }

    .desc2 {
        padding-top: 26px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .desc3 {
        padding-top: 24px;
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .rankItem {
        .rankItem_productimg {
            width: 148px;
            height: 100%;
            position: relative;
            padding:13px 0;
            box-sizing: border-box;
            .img{
                width: 100%;
                height: 158px;
                background-size: contain;
                background-position: center center;
                background-repeat: no-repeat;
                @include  center;
            }
        }


        .product_title {
            padding-top: 14px;
            box-sizing: border-box;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #353C46;
            line-height: 24px;
            .productname{
                padding-right:10px;
                box-sizing:border-box;
                @include linelimt(2);
            }
        }

        .product_bable {
            margin: 8px 0 0px;
            padding: 6px 16px 6px 10px;
            box-sizing: border-box;
            background-color: #43A0AC;
            font-size: 9px;
            line-height: 9px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            display: inline-block;
            position: relative;
            border-radius: 0 0 0 9px;
            &:after {
                content: '';
                position: absolute;
                right: -10px;
                top: 0;
                width: 22px;
                height: 21px;
                background-image: url('http://p1.fishqc.net/FujtO5kFbA_ovum4FQIsxSQBvCVN');
                background-size: contain;
                background-position: 0px center;
                background-repeat: no-repeat;
            }
        }

        .productdetail {
            margin: 0px 32px 16px 0;
            box-sizing: border-box;
        }

        .productitemdetail {
            font-size: 12px;

            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9B9B9B;

            .productitemdetails {
                padding: 6px 0;
                border-bottom: 1px solid #F8F8F8;

                &:last-child {
                    border-bottom: none;
                    padding-bottom: 0;
                }

                .color {
                    color: #333;
                }

                .fix-width-60 {
                    width: 76px;
                    display: inline-block;
                }
            }
        }
    }

    .secondtitle {
        padding: 0 0 10px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 32px;

        &.padding_top_24 {
            padding-top: 24px;
            box-sizing: border-box;
        }
    }
}

.rankItem {
    width: 384px;
    height: 184px;
    margin-top: 24px;
    border: 1px solid #F4F4F5;
    margin-right: 20px;
    cursor: pointer;
    &:nth-of-type(2n) {
        margin-right: 0;
    }
}

.fishblock {
    width: 100%;
    // height: 120px;
    background-color: #EBFFFE;
    padding-left: 36px;
    box-sizing: border-box;
    margin-bottom: 24px;
    padding-top: 32px;
    padding-bottom: 32px;
    &:nth-of-type(1) {
        margin-top: 32px;
    }

    &.green {
        background: #EBFFFE;
    }

    &.yellow {
        background: #FFFDF1;
    }

    &.red {
        background: #FFF5F1;
    }

    .padding_left_16 {
        padding-left: 16px;
        box-sizing: border-box;
    }
    .fishdiv{
        flex: 1;
        padding-right: 30px;
        box-sizing: border-box;
    }
    .title {

        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #53D5C2;
        line-height: 22px;
        padding-bottom: 10px;
        box-sizing: border-box;

        &.yellowcolor {
            color: #FFC72F;
        }

        &.redcolor {
            color: #FF8437;
        }
    }

    .desc {

        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 22px;
        text-align: justify;
    }


}

.desc4 {
    padding-top: 6px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.tiaochacontain {
    padding: 0 10px 0 42px;
    box-sizing: border-box;
}

.tiaochaimg {
    padding-top: 24px;
    box-sizing: border-box;
}

.tiaochatxt {
    padding-top: 14px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 24px;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.desc5 {
    padding: 0 0 16px 0px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
}

.reportinfo_text {
    width: 278px;
    height: 61px;
    background: #FFFFFF;
    border-radius: 40px;
    border: 1px solid #DBDCDC;
    position: absolute;
    right: -278px;
    bottom: 8px;
    padding: 6px 20px 0 56px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 24px;

    .position_left {
        position: absolute;
        left: -36px;
        top: -12px;
    }
}

.reportinfo_img1 {
    width: 484px;
    height: 293px;
    background-color: #eee;
}

.reportinfo_img2 {
    width: 369px;
    height: 200px;
    line-height: 200px;
    background-color: #666;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.reportinfo_img3 {
    width: 238px;
    height: 200px;
    line-height: 200px;
    background-color: #666;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.vs-right-ul_left {
    padding-left: 24px;
    box-sizing: border-box;
}

.vs-right-li {
    height: 32px;
    line-height: 32px;
    background: #F0FFFC;
    border-radius: 16px;
    background-color: #F0FFFC;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #60DEB4;
    padding: 0 20px 0 30px;
    margin-bottom: 14px;
    display: inline-block;
    position: relative;

    &:before {
        content: '';
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        background-color: #60DEB4;
        position: absolute;
        left: 9px;
        top: 10px;
    }

    &.grave{
        color:#A8A8AD;
        background-color: #F4F4F5;
        padding:0  15px ;
        margin-left: 13px;
        &:before {
            content: '';
            width: 13px;
            height: 13px;
            display: inline-block;
            border-radius: 50%;
            background-color: #A8A8AD;
            position: absolute;
            left: -19px;
            top: 10px;
        }
    }
}

.padding_top_24 {
    padding-top: 24px;
    box-sizing: border-box;
}

.desc6 {
    padding: 16px 0;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 28px;
}

.desc7 {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 32px;
    padding-bottom: 22px;
}

.desc8 {
    padding-left: 30px;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.desc9 {
    padding-bottom: 16px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;

    .strong {
        font-weight: bold;
    }
}

.padding_top_32 {
    padding-top: 32px !important;
    box-sizing: border-box;
}

.padding_bottom_30 {
    padding-bottom: 30px;
    box-sizing: border-box;
}

.fishqc_tech_title {
    box-sizing: border-box;
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #262633;
    line-height: 26px;
    width:260px;
    padding-left: 40px;
    
    span{
        font-size: 18px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #262633;
        line-height: 26px;
    }
    &.lie2{
        width:240px;
        padding-left: 40px;
        text-align: justify;
    }

    &.lie3{
        width:200px;
        padding-left: 40px;
    }

    &.lie4{
    }

    &.margin_left_42 {
        margin-left: 42px;
    }

    &.margin_left_50 {
        margin-left: 50px;
    }


}

.height_80 {
    width: 100%;
    height: 80px;
    padding-top: 14px;
    box-sizing: border-box;
    background-color: #F8FBFD;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150 {
    width: 100%;
    height: 150px;
    background-color: #F1FFFA;
    padding-top: 32px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150_yellow {
    width: 100%;
    height: 150px;
    background-color: #FFFDF1;
    padding-top: 32px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150_red {
    width: 100%;
    height: 150px;
    background-color: #FFF5F1;
    padding-top: 16px;
    box-sizing: border-box;
}

.collect_btn{
    width: 144px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #60DEB4;
    margin:52px auto 62px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 48px;
    letter-spacing: 4px;
    padding-left:70px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
   &:before{
        content:'';
        position: absolute;
        left: 38px;
        top:50%;
        transform:translate(0,-50%);
        width:20px;
        height: 20px;
        background-image: url('http://p1.fishqc.net/Flc4z_hWNfyrvJfg1gMSux-xxqAG');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
   }
   &.active{
        &:before{
            content:'';
            position: absolute;
            left: 38px;
            top:50%;
            transform:translate(0,-50%);
            width:20px;
            height: 20px;
            background-image: url('http://p1.fishqc.net/FoKkNmGg00gPWcvsodcw43dcIc6n');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
       }
   }
}
.collect_btn_top{
    width: 144px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #60DEB4;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 48px;
    letter-spacing: 4px;
    padding-left:40px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    width: 88px;
    height: 32px;
    line-height:32px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #60DEB4;
    display: inline-block;
   &:before{
        content:'';
        position: absolute;
        left: 16px;
        top:50%;
        transform:translate(0,-50%);
        width:18px;
        height: 18px;
        background-image: url('http://p1.fishqc.net/Flc4z_hWNfyrvJfg1gMSux-xxqAG');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
   }
   &.active{
        &:before{
            content:'';
            position: absolute;
            left: 16px;
            top:50%;
            transform:translate(0,-50%);
            width:18px;
            height: 18px;
            background-image: url('http://p1.fishqc.net/FoKkNmGg00gPWcvsodcw43dcIc6n');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
       }
   }
}
.publish{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 12px;
}
.share{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 12px;
}
.fixmenu{
    position: fixed;
    top:132px;
}

.rank_introductdesc{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 28px;
    margin-top: 26px;
}
.eeq_contain{
    padding:24px 0 20px;
    box-sizing: border-box;
}
.rank_eeqdesc{
    width: 76px;
    height: 64px;
    font-size: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 32px;
    text-align: left;
    margin-top: 48px;
    margin-right: 20px;
    &.margin_top_12{
        margin-top: 12px;
    }

}
.rank_eeq_middle{
    width: 113px;
    height: 42px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 19px;
    margin:22px 6px 0;
}
.eeq_margin{
    margin:0px 8px 26px;
}
.rank_eeq_num{

    font-size: 23px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #424242;
    line-height: 32px;
}

.rank_eeq_content{
    font-size: 13px;
    font-family:  PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 14px;
    padding-top: 12px;
    box-sizing: border-box;
    &.three{
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #424242;
        line-height: 28px;
    }
}

.rank_effect_title{
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 32px;
    padding: 32px 0 16px;
    box-sizing: border-box;
}

.rank_effect_subtitle{
    
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 28px;
}

.rank_effect_result{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 28px;
    padding-top: 32px;
    box-sizing: border-box;
}
.rank_share_icon{
    width:32px;
    height: 32px;
    background: pink;
    border-radius: 50%;
    margin:0 10px;
    display: inline-block;
    vertical-align: middle;
}

.fontSize12{
    font-size: 12px;
    margin-top: 0;
    line-height: 22px;
}

.fontSize16{
    font-size: 16px;
}
</style>

<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import fishqcinfo from '@/components/fishqcInfo.vue'
import {getrankdetailApi ,collectApi } from '@/api/api.js'
import { myMixin } from '@/mixin/mixin.js'
import {formatTime} from '@/utils/other.js'
import Modal from '@/components/Modal.vue'
export default {
    name: '',
    components: {
        banner,
        fishqcinfo,
        modal:Modal
    },
    mixins: [myMixin],
    data() {
        return {
            rank_fish_desc: {
                'green': {
                    class: 'green',
                    textcolor: '',
                    fish: 'http://p1.fishqc.net/FjFwYIpjv8nV8yrfUg8O1ByMm-EF',
                    title: this.$t('common.green_Title'),
                    desc: this.$t('common.green_evaluation')
                },
                'yellow': {
                    class: 'yellow',
                    textcolor: 'yellowcolor',
                    fish: 'http://p1.fishqc.net/FkwJBCGNGbTokp_j7_k_YDjS7LM5',
                    title: this.$t('common.yellow_Title'),
                    desc: this.$t('common.yellow_evaluation')
                },
                'red': {
                    class: 'red',
                    textcolor: 'redcolor',
                    fish: 'http://p1.fishqc.net/Fsj1cltSch3P6j5y4HuKnx8r_Y9q',
                    title: this.$t('common.red_Title'),
                    desc:this.$t('common.red_evaluation')
                }
            },
            fixbox:false,
            toolRight:40,
            ranktype:'single',
            // rankmenu:{
            //     'greenrank':{
            //         title:this.$t('index.rankTitle'),
            //         position:'greenrank',
            //         show:true
            //     },
            //     'standard':{
            //         title:this.$t('rankindex.report_standard'),
            //         position:'standard',
            //         show:true

            //     },
            //     'technology':{
            //         title:this.$t('rankindex.fishqcintroduction'),
            //         position:'technology',
            //         show:true
            //     },
            //     'efficacy':{
            //         title:'功效测评科技',
            //         position:'efficacy',
            //         show:true
            //     },
                
            // },
            rankdata:{}, // 榜单数据
            efficacy:'1,2,3',
            collectflag:false,
            ismodalshow:false,
            currentlang:'',
            currentranktitle:''
           
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper1.$swiper
        },
        // efficacyTest : 功效测试，0无，1美白，2抗衰老，3修复，4抗炎，5保湿
        // 计算属性的 getter
        efficacyTestString: function (efficacy) {
          // `this` 指向 vm 实例
          // return  efficacy.split('')
          // return this.message.split('').reverse().join('')
        },
        formatTimefun(){
            return function(ctime){
                if(ctime){
                    return formatTime(ctime,'Y/M/D')
                }
                
            }
        },
        rankmenu(){
            return function(){
                var that = this
                var object  = {}
                

                
                    object['greenrank'] = {
                        title:that.$t('index.rankTitle'),
                        position:'greenrank',
                        show:true
                    }
                    object['standard'] = {
                        title:that.$t('rankindex.report_standard'),
                        position:'standard',
                        show:true
                    }
                    object['technology'] = {
                        title:that.$t('rankindex.fishqcintroduction'),
                        position:'technology',
                        show:true
                    }
                    if(that.rankdata.efficacyTest !=null && that.rankdata.efficacyTest!=='0'){
                        console.log('有功效')
                        object['efficacy'] = {
                            title:'功效测评科技',
                            position:'efficacy',
                            show:true
                        }
                    }else{
                        object['efficacy'] = {
                            title:'功效测评科技',
                            position:'efficacy',
                            show:false
                        }
                    }
                
                
                

                return object



                
            }
                
                
        }

    },
    mounted() {
        this.currentlang = window.localStorage.getItem("LOCALE")
        var winWidth = document.documentElement.clientWidth || document.body.clientWidth;
        var rightGap = (winWidth-1200)/2;
        this.toolRight = rightGap > 0 ? rightGap*1 : 0;
      
        this.$nextTick(function () {
            window.addEventListener('scroll', this.handleScroll,true);
        });
        this.getrankdetail()
    },
    methods: {
        tapchoose(item) {
            if (item.type == 'rank') {
                this.getranklist()
            } else {
                this.getreportlist()
                       
            }
        },
        handleScroll() {
            let dom =document.getElementsByClassName('content-container')[0];
            // console.log('elTop>>>>>>>>>>>',dom.scrollTop)
            let sTop = document.documentElement.scrollTop == 0 ? document.body.scrollTop : document.documentElement.scrollTop;
            // console.log('documentTop>>>',sTop);
            if(sTop > 532 || dom > 532){
                this.fixbox = true
            }else{
                this.fixbox = false;
            }
        },
        scrollTo(title,position){
            console.log(title,position)
            var that = this;
            that.currentranktitle = title
            var  scroll_H ;
            this.$nextTick(function(){
                if(position == 'greenrank'){
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                }else{
                    scroll_H = this.$refs[position].offsetTop-110; //减去header高度
                }
                
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        getrankdetail(){
            getrankdetailApi({
                rankingUnionId:this.$route.params.id,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.rankdata = res.data
                }else if(res.code == 403){  //未购买
                    this.ismodalshow = true
                    this.$refs.modaltoast.show({
                        type:'guide',  //弹窗类型，guide:导购页
                        itemtype:'1',    //报告
                        itemdata:res.data,
                        source:'detail'
                    });

                }else if(res.code == 401){  //未登录
                    this.ismodalshow = true
                    this.$refs.modaltoast.show({
                        type:'guide',  //弹窗类型，guide:导购页
                        itemtype:'1',    //报告
                        itemdata:res.data,
                        source:'detail'
                    });

                }else if(res.code == 400){
                    this.$router.push({
                        path: '/Page404'
                    })
                } else {
                    this.toast(res.message)

                }
            })
        },
        // 收藏
        collect(){
            var  that = this
            if(that.collectflag){
                return
            }
            this.collectflag = true
            collectApi({
                id:this.$route.params.id,
                type:12
            }).then(res => {
                that.collectflag = false
                if (res.code == 200) {
                    if(that.rankdata.favor){
                        this.toast(this.$t('common.cancelcollect'))
                        that.rankdata.favor = false
                    }else {
                        that.rankdata.favor = true
                        this.toast(this.$t('common.successcollect'))
                    }
                   
                }else if(res.code == 401){
                    this.toast(this.$t('common.loginfirst'))
                }else {
                    this.toast(res.message)
                }
            })
        },
        toproductdetail(item) {
            this.$router.push({
                path: '/product/'+item.productType+'/'+item.productId
            })
        },
        getmaterial(e){
            console.log('回调弹窗关闭状态',e)
            this.ismodalshow = e.showstatus
        },
    }
}
</script>